export default {
  title_points: 'Comprar puntos',
  title_daypass: 'Comprar daypass',
  title_signature: 'Sign documents',
  message: {
    complete_main: 'Proceso completado. Puedes cerrar esta ventana.',
    error: 'Ha ocurrido un error. Contacta un administrador si persiste.'
  },
  form: {
    name: 'Nombre',
    surname: 'Apellidos',
    guest: 'Dueño de la cuenta',
    transaction_guest: 'Compra realizada por',
    current_balance: 'Saldo actual',
    final_balance: 'Saldo final',
    amount: 'Compra',
    price: 'Precio',
    price_conversion: 'Conversión de precio',
    payment_currency: 'Divisa de pago',
    payment_method: 'Método de pago',
    numberGuests: 'Número de huéspedes',
    facility: 'Instalación',
    conversion: 'Cambio de divisa',
    currency: 'Divisa',
    paymentMethod: 'Método de pago',
    paymentMethodAction: 'Selecciona método de pago',
    observations: 'Observaciones'
  },
  transaction_types: {
    payment: 'Pago instantáneo',
    booking: 'Cargo a habitación'
  },
  actions: {
    purchase_points: 'Comprar {amount} {currency}',
    purchase: 'Comprar',
    reset: 'Resetear',
    submit: 'Enviar'
  },
  warnings: {
    no_exchange_rate: 'No existe un valor de cambio asociado a esta divisa'
  },
  points: {
    discount: 'Este huésped tiene un descuento del {discount}%',
    disabled_account: 'Cuenta inactiva',
    no_station: 'Es necesario configurar una estación en el panel para proceder',
    no_base_currency_allowed: 'La estación configurada no tiene permitido utilizar la divisa de la instalación',
    no_points_currency_allowed: 'La estación configurada no tiene permitido utilizar la divisa de puntos'
  },
  signature: {
    terms_title: 'Aprobación de uso de pulsera',
    terms_body: `
      Los brazaletes se utilizan como identificadores de los huéspedes en áreas y centros de consumo del hotel y para abrir la habitación asignada. Autorizo a las personas que viajan conmigo enlistadas a continuación, el uso de los brazaletes para realizar cargos adicionales a la habitación y utilizar los Joe Merchant´s Points asignados a la misma habitación. El número de serie de brazalete asignado puede cambiar de ser necesario el cambio o reposición del brazalete durante la estancia. La reposición del brazalete tiene un cargo extra en caso de pérdida o extravío. Los brazaletes serán desactivados al check out. <br/><br/>
      Estoy al tanto que los Joe Merchant´s Points pueden ser utilizados únicamente para compras en Joe Merchant´s, que la asignación de los Joe Merchant´s Points se realiza en un solo depósito por habitación, de acuerdo con la categoría de habitación y número de noches reservadas y que los huéspedes adultos asignados a la misma habitación comparten los puntos. Podrán activar los brazaletes para uso de Joe Merchant´s Points únicamente los menores autorizados por el titular. Los Joe Merchant´s Points no son intercambiables por dinero, no son transferibles, expiran al momento del Check out, y no son reembolsables. Los Joe Merchant´s Points no son acumulables por estancias anteriores. En caso de que el huésped solicite un up grade, se actualizarán los Joe Merchant´s Points de acuerdo con el tipo habitación. Cuando sea efectivo el up grade, se completa el depósito de acuerdo con los Joe Merchant´s Points extras que corresponda a partir de ese día. No se asignarán retroactivos. El huésped podrá comprar paquetes de puntos adicionales en Joe Merchant´s o recepción. Si faltan Joe Merchant´s Points para realizar alguna compra, el importe restante se carga a la habitación, o será cubierto con otros métodos autorizados. El envío de compras en Joe Merchant´s a la habitación tiene cargo extra que podrá pagarse con puntos u otras formas de pago autorizadas. Queda prohibido el consumo de productos comprados en Joe Merchant’s en áreas de consumo (restaurantes y bares) del hotel. El único producto aceptado para llevar al área de consumo (restaurantes y bares) serán botellas de vino cerradas. Los Joe Merchant´s Points no pueden ser utilizados como propinas, spa, etc., son exclusivos para Joe Merchant´s.
    `,
    guests_list: 'Huéspedes autorizados para el uso del brazalete:',
    guest_selected: 'Selecciona el huésped que firma:',
    sign_acceptance: 'Estoy de acuerdo con las condiciones de uso definidas en este documento',
    selec_lang: 'Elige el idioma',
    langs: [
      {
        name: 'Español',
        code: 'es'
      },
      {
        name: 'Inglés',
        code: 'en'
      }
    ],
    room: 'Habitación {name}',
    no_room: 'Sin habitación'
  }
}
